import {styled} from "@mui/material";

export const ToolBarContainer = styled('div')(() => {
    return {
        backgroundColor: '#fff',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        position: 'relative',
        paddingRight: '1rem',
        paddingLeft: '1rem',
        paddingBottom: '1rem',
        gap: '1rem',

        '& .MuiTabs-root': {
            borderBottom: '1px solid #F1F1FB',
        }
    }
});

export const FilterButton = styled('div')(() => {
    return {
        '& img': {
            marginRight: '0.75rem'
        }
    }
});

export const FilterArrowIcon = styled('img')(() => ({
    marginLeft: '12px'
}));

export const FilterOpened = styled('div')(() => {
    return {
        width: '100%',
        display: 'flex',
        paddingRight: '1.5rem',
        gap: '1rem',
        paddingTop: '0.5rem',
        overflowX: 'auto'
    }
});
export const FilterOpenedMobile = styled(FilterOpened)(() => {
    return {
        padding: '1.5rem',
        flexDirection: 'column',
    }
});

export const FilterButtonsContainer = styled('div')(() => {
    return {
        display: 'flex',
        alignItems: 'center',
    }
});
